(() => {
  const designs = {
"champagne-supernova": { source: "https://cdn.shopify.com/s/files/1/0086/7103/5455/files/champagne-supernova-two-hues.png?v=1790953533", colors: [{"name": "Black", "hex": "#1c1c1c", "source": "Charcoal"}, {"name": "Chartreuse", "hex": "#aa9017", "source": "Chartreuse"}, {"name": "Cherry Red", "hex": "#c50603", "source": "Cherry"}, {"name": "Gray", "hex": "#8a9496", "source": "Dove"}, {"name": "Sage", "hex": "#97a191", "source": "Eucalyptus"}, {"name": "Dusty Blue", "hex": "#7e9aae", "source": "Hydrangea"}, {"name": "Jade", "hex": "#6aa496", "source": "Jade"}, {"name": "Lavender", "hex": "#9e9dae", "source": "Lavender"}, {"name": "Lime", "hex": "#b4b777", "source": "Lime"}, {"name": "Navy", "hex": "#052d4a", "source": "Navy"}, {"name": "Olive", "hex": "#758451", "source": "Olive"}, {"name": "Pink", "hex": "#ee98b5", "source": "Peony"}, {"name": "Powder Blue", "hex": "#99b2ba", "source": "Powder"}, {"name": "Rose", "hex": "#da979f", "source": "Rose"}, {"name": "Sand", "hex": "#baac96", "source": "Sand"}, {"name": "Seafoam", "hex": "#a7bbb9", "source": "Seaglass"}, {"name": "Brown", "hex": "#79553d", "source": "Brown"}, {"name": "Peach", "hex": "#edad82", "source": "Tangerine"}, {"name": "Cranberry", "hex": "#8b2942", "source": "Cranberry"}, {"name": "Kelly Green", "hex": "#248b45", "source": "Kelly Green"}, {"name": "Butter", "hex": "#f4edb6", "source": "Butter"}, {"name": "Burnt Orange", "hex": "#bf5700", "source": "Burnt Orange"}, {"name": "Tangerine", "hex": "#ed872d", "source": "Tangerine"}, {"name": "Yellow", "hex": "#f2ce25", "source": "Yellow"}, {"name": "Mocha", "hex": "#a18470", "source": "Mocha"}], u_DrawPreview() {
      if (!this._previewSource || !this._previewCanvas) return;
      const selected = this.colors.find(item => item.name === this.colorway);
      if (!selected) return;
      const source = this._previewSource;
      const context = this._previewCanvas.getContext('2d');
      const original = source.data;
      const output = new ImageData(new Uint8ClampedArray(original), source.width, source.height);
      const rgb = selected.hex.match(/[a-f0-9]{2}/gi).map(value => parseInt(value, 16));
      const bounds = [Math.ceil(source.width * .059), Math.floor(source.width * .941), Math.ceil(source.height * .0595), Math.floor(source.height * .929)];
      if (!this._photoColors) {
        const samples = [];
        for (let y = bounds[2]; y < bounds[3]; y += 5) {
          for (let x = bounds[0]; x < bounds[1]; x += 5) {
            const i = (y * source.width + x) * 4;
            samples.push([original[i], original[i+1], original[i+2]]);
          }
        }
        const light = p => (p[0] + p[1] + p[2]) / 3;
        samples.sort((a,b) => light(a) - light(b));
        let centers = [samples[Math.floor(samples.length * .15)].slice(), samples[Math.floor(samples.length * .85)].slice()];
        for (let pass = 0; pass < 12; pass++) {
          const sums = [[0,0,0,0],[0,0,0,0]];
          for (const p of samples) {
            const distances = centers.map(c => p.reduce((sum,v,k) => sum + (v-c[k]) ** 2, 0));
            const group = distances[0] < distances[1] ? 0 : 1;
            for (let k=0;k<3;k++) sums[group][k] += p[k];
            sums[group][3]++;
          }
          centers = centers.map((c,g) => sums[g][3] ? sums[g].slice(0,3).map(v => v/sums[g][3]) : c);
        }
        centers.sort((a,b) => light(a) - light(b));
        this._photoColors = centers;
      }
      const [ink, white] = this._photoColors;
      const delta = white.map((v,k) => ink[k]-v);
      const norm = delta.reduce((sum,v) => sum+v*v,0);
      const coloredBase = true;
      const sourceInkIsTargetInk = (this.direction === 'Reverse') === coloredBase;
      const neutralWhite = [250, 250, 248];
      const targetInk = sourceInkIsTargetInk ? rgb : neutralWhite;
      const targetWhite = sourceInkIsTargetInk ? neutralWhite : rgb;
      for (let y=bounds[2];y<bounds[3];y++) {
        for (let x=bounds[0];x<bounds[1];x++) {
          const i=(y*source.width+x)*4;
          let t=0;
          for(let k=0;k<3;k++) t+=(original[i+k]-white[k])*delta[k];
          t=Math.max(0,Math.min(1,t/norm));
          const alpha=t*t*(3-2*t);
          const sourceLight = (original[i] + original[i+1] + original[i+2]) / 3;
          const expectedLight = (white[0] + white[1] + white[2] + alpha * (delta[0] + delta[1] + delta[2])) / 3;
          const texture = Math.max(0.88, Math.min(1.08, sourceLight / Math.max(1, expectedLight)));
          for(let k=0;k<3;k++) {
            const target=targetWhite[k]*(1-alpha)+targetInk[k]*alpha;
            output.data[i+k]=target*texture;
          }
        }
      }
      context.putImageData(output,0,0);
      this._previewCanvas.setAttribute('aria-label', this.colorway + ', ' + this.direction.toLowerCase() + ' color placement');
    } },
"danton": { source: "https://cdn.shopify.com/s/files/1/0086/7103/5455/files/danton-two-hues.png?v=1790954352", colors: [{"name": "Black", "hex": "#1c1c1c", "source": "Charcoal"}, {"name": "Chartreuse", "hex": "#aa9017", "source": "Chartreuse"}, {"name": "Cherry Red", "hex": "#c50603", "source": "Cherry"}, {"name": "Gray", "hex": "#8a9496", "source": "Dove"}, {"name": "Sage", "hex": "#97a191", "source": "Eucalyptus"}, {"name": "Dusty Blue", "hex": "#7e9aae", "source": "Hydrangea"}, {"name": "Jade", "hex": "#6aa496", "source": "Jade"}, {"name": "Lavender", "hex": "#9e9dae", "source": "Lavender"}, {"name": "Lime", "hex": "#b4b777", "source": "Lime"}, {"name": "Navy", "hex": "#052d4a", "source": "Navy"}, {"name": "Olive", "hex": "#758451", "source": "Olive"}, {"name": "Pink", "hex": "#ee98b5", "source": "Peony"}, {"name": "Powder Blue", "hex": "#99b2ba", "source": "Powder"}, {"name": "Rose", "hex": "#da979f", "source": "Rose"}, {"name": "Sand", "hex": "#baac96", "source": "Sand"}, {"name": "Seafoam", "hex": "#a7bbb9", "source": "Seaglass"}, {"name": "Brown", "hex": "#79553d", "source": "Brown"}, {"name": "Peach", "hex": "#edad82", "source": "Tangerine"}, {"name": "Cranberry", "hex": "#8b2942", "source": "Cranberry"}, {"name": "Kelly Green", "hex": "#248b45", "source": "Kelly Green"}, {"name": "Butter", "hex": "#f4edb6", "source": "Butter"}, {"name": "Burnt Orange", "hex": "#bf5700", "source": "Burnt Orange"}, {"name": "Tangerine", "hex": "#ed872d", "source": "Tangerine"}, {"name": "Yellow", "hex": "#f2ce25", "source": "Yellow"}, {"name": "Mocha", "hex": "#a18470", "source": "Mocha"}], u_DrawPreview() {
      if (!this._previewSource || !this._previewCanvas) return;
      const selected = this.colors.find(item => item.name === this.colorway);
      if (!selected) return;
      const source = this._previewSource;
      const context = this._previewCanvas.getContext('2d');
      const original = source.data;
      const output = new ImageData(new Uint8ClampedArray(original), source.width, source.height);
      const rgb = selected.hex.match(/[a-f0-9]{2}/gi).map(value => parseInt(value, 16));
      const bounds = [Math.ceil(source.width * .059), Math.floor(source.width * .941), Math.ceil(source.height * .0595), Math.floor(source.height * .929)];
      if (!this._photoColors) {
        const samples = [];
        for (let y = bounds[2]; y < bounds[3]; y += 5) {
          for (let x = bounds[0]; x < bounds[1]; x += 5) {
            const i = (y * source.width + x) * 4;
            samples.push([original[i], original[i+1], original[i+2]]);
          }
        }
        const light = p => (p[0] + p[1] + p[2]) / 3;
        samples.sort((a,b) => light(a) - light(b));
        let centers = [samples[Math.floor(samples.length * .15)].slice(), samples[Math.floor(samples.length * .85)].slice()];
        for (let pass = 0; pass < 12; pass++) {
          const sums = [[0,0,0,0],[0,0,0,0]];
          for (const p of samples) {
            const distances = centers.map(c => p.reduce((sum,v,k) => sum + (v-c[k]) ** 2, 0));
            const group = distances[0] < distances[1] ? 0 : 1;
            for (let k=0;k<3;k++) sums[group][k] += p[k];
            sums[group][3]++;
          }
          centers = centers.map((c,g) => sums[g][3] ? sums[g].slice(0,3).map(v => v/sums[g][3]) : c);
        }
        centers.sort((a,b) => light(a) - light(b));
        this._photoColors = centers;
      }
      const [ink, white] = this._photoColors;
      const delta = white.map((v,k) => ink[k]-v);
      const norm = delta.reduce((sum,v) => sum+v*v,0);
      const coloredBase = true;
      const sourceInkIsTargetInk = (this.direction === 'Reverse') === coloredBase;
      const neutralWhite = [250, 250, 248];
      const targetInk = sourceInkIsTargetInk ? rgb : neutralWhite;
      const targetWhite = sourceInkIsTargetInk ? neutralWhite : rgb;
      for (let y=bounds[2];y<bounds[3];y++) {
        for (let x=bounds[0];x<bounds[1];x++) {
          const i=(y*source.width+x)*4;
          let t=0;
          for(let k=0;k<3;k++) t+=(original[i+k]-white[k])*delta[k];
          t=Math.max(0,Math.min(1,t/norm));
          const alpha=t*t*(3-2*t);
          const sourceLight = (original[i] + original[i+1] + original[i+2]) / 3;
          const expectedLight = (white[0] + white[1] + white[2] + alpha * (delta[0] + delta[1] + delta[2])) / 3;
          const texture = Math.max(0.88, Math.min(1.08, sourceLight / Math.max(1, expectedLight)));
          for(let k=0;k<3;k++) {
            const target=targetWhite[k]*(1-alpha)+targetInk[k]*alpha;
            output.data[i+k]=target*texture;
          }
        }
      }
      context.putImageData(output,0,0);
      this._previewCanvas.setAttribute('aria-label', this.colorway + ', ' + this.direction.toLowerCase() + ' color placement');
    } },
"la-vie-en-rose": { source: "https://cdn.shopify.com/s/files/1/0086/7103/5455/files/la-vie-en-rose-two-hues.png?v=1790954023", colors: [{"name": "Black", "hex": "#1c1c1c", "source": "Charcoal"}, {"name": "Chartreuse", "hex": "#aa9017", "source": "Chartreuse"}, {"name": "Cherry Red", "hex": "#c50603", "source": "Cherry"}, {"name": "Gray", "hex": "#8a9496", "source": "Dove"}, {"name": "Sage", "hex": "#97a191", "source": "Eucalyptus"}, {"name": "Dusty Blue", "hex": "#7e9aae", "source": "Hydrangea"}, {"name": "Jade", "hex": "#6aa496", "source": "Jade"}, {"name": "Lavender", "hex": "#9e9dae", "source": "Lavender"}, {"name": "Lime", "hex": "#b4b777", "source": "Lime"}, {"name": "Navy", "hex": "#052d4a", "source": "Navy"}, {"name": "Olive", "hex": "#758451", "source": "Olive"}, {"name": "Pink", "hex": "#ee98b5", "source": "Peony"}, {"name": "Powder Blue", "hex": "#99b2ba", "source": "Powder"}, {"name": "Rose", "hex": "#da979f", "source": "Rose"}, {"name": "Sand", "hex": "#baac96", "source": "Sand"}, {"name": "Seafoam", "hex": "#a7bbb9", "source": "Seaglass"}, {"name": "Brown", "hex": "#79553d", "source": "Brown"}, {"name": "Peach", "hex": "#edad82", "source": "Tangerine"}, {"name": "Cranberry", "hex": "#8b2942", "source": "Cranberry"}, {"name": "Kelly Green", "hex": "#248b45", "source": "Kelly Green"}, {"name": "Butter", "hex": "#f4edb6", "source": "Butter"}, {"name": "Burnt Orange", "hex": "#bf5700", "source": "Burnt Orange"}, {"name": "Tangerine", "hex": "#ed872d", "source": "Tangerine"}, {"name": "Yellow", "hex": "#f2ce25", "source": "Yellow"}, {"name": "Mocha", "hex": "#a18470", "source": "Mocha"}], u_DrawPreview() {
      if (!this._previewSource || !this._previewCanvas) return;
      const selected = this.colors.find(item => item.name === this.colorway);
      if (!selected) return;
      const source = this._previewSource;
      const context = this._previewCanvas.getContext('2d');
      const original = source.data;
      const output = new ImageData(new Uint8ClampedArray(original), source.width, source.height);
      const rgb = selected.hex.match(/[a-f0-9]{2}/gi).map(value => parseInt(value, 16));
      const bounds = [Math.ceil(source.width * .059), Math.floor(source.width * .941), Math.ceil(source.height * .0595), Math.floor(source.height * .929)];
      if (!this._photoColors) {
        const samples = [];
        for (let y = bounds[2]; y < bounds[3]; y += 5) {
          for (let x = bounds[0]; x < bounds[1]; x += 5) {
            const i = (y * source.width + x) * 4;
            samples.push([original[i], original[i+1], original[i+2]]);
          }
        }
        const light = p => (p[0] + p[1] + p[2]) / 3;
        samples.sort((a,b) => light(a) - light(b));
        let centers = [samples[Math.floor(samples.length * .15)].slice(), samples[Math.floor(samples.length * .85)].slice()];
        for (let pass = 0; pass < 12; pass++) {
          const sums = [[0,0,0,0],[0,0,0,0]];
          for (const p of samples) {
            const distances = centers.map(c => p.reduce((sum,v,k) => sum + (v-c[k]) ** 2, 0));
            const group = distances[0] < distances[1] ? 0 : 1;
            for (let k=0;k<3;k++) sums[group][k] += p[k];
            sums[group][3]++;
          }
          centers = centers.map((c,g) => sums[g][3] ? sums[g].slice(0,3).map(v => v/sums[g][3]) : c);
        }
        centers.sort((a,b) => light(a) - light(b));
        this._photoColors = centers;
      }
      const [ink, white] = this._photoColors;
      const delta = white.map((v,k) => ink[k]-v);
      const norm = delta.reduce((sum,v) => sum+v*v,0);
      const coloredBase = true;
      const sourceInkIsTargetInk = (this.direction === 'Reverse') === coloredBase;
      const neutralWhite = [250, 250, 248];
      const targetInk = sourceInkIsTargetInk ? rgb : neutralWhite;
      const targetWhite = sourceInkIsTargetInk ? neutralWhite : rgb;
      for (let y=bounds[2];y<bounds[3];y++) {
        for (let x=bounds[0];x<bounds[1];x++) {
          const i=(y*source.width+x)*4;
          let t=0;
          for(let k=0;k<3;k++) t+=(original[i+k]-white[k])*delta[k];
          t=Math.max(0,Math.min(1,t/norm));
          const alpha=t*t*(3-2*t);
          const sourceLight = (original[i] + original[i+1] + original[i+2]) / 3;
          const expectedLight = (white[0] + white[1] + white[2] + alpha * (delta[0] + delta[1] + delta[2])) / 3;
          const texture = Math.max(0.88, Math.min(1.08, sourceLight / Math.max(1, expectedLight)));
          for(let k=0;k<3;k++) {
            const target=targetWhite[k]*(1-alpha)+targetInk[k]*alpha;
            output.data[i+k]=target*texture;
          }
        }
      }
      context.putImageData(output,0,0);
      this._previewCanvas.setAttribute('aria-label', this.colorway + ', ' + this.direction.toLowerCase() + ' color placement');
    } },
"leo": { source: "https://cdn.shopify.com/s/files/1/0086/7103/5455/files/leo-two-hues.png?v=1790950452", colors: [{"name": "Black", "hex": "#1c1c1c", "source": "Charcoal"}, {"name": "Chartreuse", "hex": "#aa9017", "source": "Chartreuse"}, {"name": "Cherry Red", "hex": "#c50603", "source": "Cherry"}, {"name": "Gray", "hex": "#8a9496", "source": "Dove"}, {"name": "Sage", "hex": "#97a191", "source": "Eucalyptus"}, {"name": "Dusty Blue", "hex": "#7e9aae", "source": "Hydrangea"}, {"name": "Jade", "hex": "#6aa496", "source": "Jade"}, {"name": "Lavender", "hex": "#9e9dae", "source": "Lavender"}, {"name": "Lime", "hex": "#b4b777", "source": "Lime"}, {"name": "Navy", "hex": "#052d4a", "source": "Navy"}, {"name": "Olive", "hex": "#758451", "source": "Olive"}, {"name": "Pink", "hex": "#ee98b5", "source": "Peony"}, {"name": "Powder Blue", "hex": "#99b2ba", "source": "Powder"}, {"name": "Rose", "hex": "#da979f", "source": "Rose"}, {"name": "Sand", "hex": "#baac96", "source": "Sand"}, {"name": "Seafoam", "hex": "#a7bbb9", "source": "Seaglass"}, {"name": "Brown", "hex": "#79553d", "source": "Brown"}, {"name": "Peach", "hex": "#edad82", "source": "Tangerine"}, {"name": "Cranberry", "hex": "#8b2942", "source": "Cranberry"}, {"name": "Kelly Green", "hex": "#248b45", "source": "Kelly Green"}, {"name": "Butter", "hex": "#f4edb6", "source": "Butter"}, {"name": "Burnt Orange", "hex": "#bf5700", "source": "Burnt Orange"}, {"name": "Tangerine", "hex": "#ed872d", "source": "Tangerine"}, {"name": "Yellow", "hex": "#f2ce25", "source": "Yellow"}, {"name": "Mocha", "hex": "#a18470", "source": "Mocha"}], u_DrawPreview() {
      if (!this._previewSource || !this._previewCanvas) return;
      const selected = this.colors.find(item => item.name === this.colorway);
      if (!selected) return;
      const source = this._previewSource;
      const context = this._previewCanvas.getContext('2d');
      const original = source.data;
      const output = new ImageData(new Uint8ClampedArray(original), source.width, source.height);
      const rgb = selected.hex.match(/[a-f0-9]{2}/gi).map(value => parseInt(value, 16));
      const bounds = [Math.ceil(source.width * .059), Math.floor(source.width * .941), Math.ceil(source.height * .0595), Math.floor(source.height * .929)];
      if (!this._photoColors) {
        const samples = [];
        for (let y = bounds[2]; y < bounds[3]; y += 5) {
          for (let x = bounds[0]; x < bounds[1]; x += 5) {
            const i = (y * source.width + x) * 4;
            samples.push([original[i], original[i+1], original[i+2]]);
          }
        }
        const light = p => (p[0] + p[1] + p[2]) / 3;
        samples.sort((a,b) => light(a) - light(b));
        let centers = [samples[Math.floor(samples.length * .15)].slice(), samples[Math.floor(samples.length * .85)].slice()];
        for (let pass = 0; pass < 12; pass++) {
          const sums = [[0,0,0,0],[0,0,0,0]];
          for (const p of samples) {
            const distances = centers.map(c => p.reduce((sum,v,k) => sum + (v-c[k]) ** 2, 0));
            const group = distances[0] < distances[1] ? 0 : 1;
            for (let k=0;k<3;k++) sums[group][k] += p[k];
            sums[group][3]++;
          }
          centers = centers.map((c,g) => sums[g][3] ? sums[g].slice(0,3).map(v => v/sums[g][3]) : c);
        }
        centers.sort((a,b) => light(a) - light(b));
        this._photoColors = centers;
      }
      const [ink, white] = this._photoColors;
      const delta = white.map((v,k) => ink[k]-v);
      const norm = delta.reduce((sum,v) => sum+v*v,0);
      const coloredBase = false;
      const sourceInkIsTargetInk = (this.direction === 'Reverse') === coloredBase;
      const neutralWhite = [245,245,245];
      const targetInk = sourceInkIsTargetInk ? rgb : neutralWhite;
      const targetWhite = sourceInkIsTargetInk ? neutralWhite : rgb;
      for (let y=bounds[2];y<bounds[3];y++) {
        for (let x=bounds[0];x<bounds[1];x++) {
          const i=(y*source.width+x)*4;
          let t=0;
          for(let k=0;k<3;k++) t+=(original[i+k]-white[k])*delta[k];
          t=Math.max(0,Math.min(1,t/norm));
          const alpha=t*t*(3-2*t);
          const sourceLight=(original[i]+original[i+1]+original[i+2])/3;
          const expectedLight=(white[0]+white[1]+white[2]+alpha*(delta[0]+delta[1]+delta[2]))/3;
          const texture=sourceLight/Math.max(1,expectedLight);
          for(let k=0;k<3;k++) {
            const target=targetWhite[k]*(1-alpha)+targetInk[k]*alpha;
            output.data[i+k]=target*texture;
          }
        }
      }
      context.putImageData(output,0,0);
      this._previewCanvas.setAttribute('aria-label', this.colorway + ', ' + this.direction.toLowerCase() + ' color placement');
    } },
"margot": { source: "https://cdn.shopify.com/s/files/1/0086/7103/5455/files/margot-two-hues.png?v=1790952358", colors: [{"name": "Black", "hex": "#1c1c1c", "source": "Charcoal"}, {"name": "Chartreuse", "hex": "#aa9017", "source": "Chartreuse"}, {"name": "Cherry Red", "hex": "#c50603", "source": "Cherry"}, {"name": "Gray", "hex": "#8a9496", "source": "Dove"}, {"name": "Sage", "hex": "#97a191", "source": "Eucalyptus"}, {"name": "Dusty Blue", "hex": "#7e9aae", "source": "Hydrangea"}, {"name": "Jade", "hex": "#6aa496", "source": "Jade"}, {"name": "Lavender", "hex": "#9e9dae", "source": "Lavender"}, {"name": "Lime", "hex": "#b4b777", "source": "Lime"}, {"name": "Navy", "hex": "#052d4a", "source": "Navy"}, {"name": "Olive", "hex": "#758451", "source": "Olive"}, {"name": "Pink", "hex": "#ee98b5", "source": "Peony"}, {"name": "Powder Blue", "hex": "#99b2ba", "source": "Powder"}, {"name": "Rose", "hex": "#da979f", "source": "Rose"}, {"name": "Sand", "hex": "#baac96", "source": "Sand"}, {"name": "Seafoam", "hex": "#a7bbb9", "source": "Seaglass"}, {"name": "Brown", "hex": "#79553d", "source": "Brown"}, {"name": "Peach", "hex": "#edad82", "source": "Tangerine"}, {"name": "Cranberry", "hex": "#8b2942", "source": "Cranberry"}, {"name": "Kelly Green", "hex": "#248b45", "source": "Kelly Green"}, {"name": "Butter", "hex": "#f4edb6", "source": "Butter"}, {"name": "Burnt Orange", "hex": "#bf5700", "source": "Burnt Orange"}, {"name": "Tangerine", "hex": "#ed872d", "source": "Tangerine"}, {"name": "Yellow", "hex": "#f2ce25", "source": "Yellow"}, {"name": "Mocha", "hex": "#a18470", "source": "Mocha"}], u_DrawPreview() {
      if (!this._previewSource || !this._previewCanvas) return;
      const selected = this.colors.find(item => item.name === this.colorway);
      if (!selected) return;
      const source = this._previewSource;
      const context = this._previewCanvas.getContext('2d');
      const original = source.data;
      const output = new ImageData(new Uint8ClampedArray(original), source.width, source.height);
      const rgb = selected.hex.match(/[a-f0-9]{2}/gi).map(value => parseInt(value, 16));
      const bounds = [Math.ceil(source.width * .059), Math.floor(source.width * .941), Math.ceil(source.height * .0595), Math.floor(source.height * .929)];
      if (!this._photoColors) {
        const samples = [];
        for (let y = bounds[2]; y < bounds[3]; y += 5) {
          for (let x = bounds[0]; x < bounds[1]; x += 5) {
            const i = (y * source.width + x) * 4;
            samples.push([original[i], original[i+1], original[i+2]]);
          }
        }
        const light = p => (p[0] + p[1] + p[2]) / 3;
        samples.sort((a,b) => light(a) - light(b));
        let centers = [samples[Math.floor(samples.length * .15)].slice(), samples[Math.floor(samples.length * .85)].slice()];
        for (let pass = 0; pass < 12; pass++) {
          const sums = [[0,0,0,0],[0,0,0,0]];
          for (const p of samples) {
            const distances = centers.map(c => p.reduce((sum,v,k) => sum + (v-c[k]) ** 2, 0));
            const group = distances[0] < distances[1] ? 0 : 1;
            for (let k=0;k<3;k++) sums[group][k] += p[k];
            sums[group][3]++;
          }
          centers = centers.map((c,g) => sums[g][3] ? sums[g].slice(0,3).map(v => v/sums[g][3]) : c);
        }
        centers.sort((a,b) => light(a) - light(b));
        this._photoColors = centers;
      }
      const [ink, white] = this._photoColors;
      const delta = white.map((v,k) => ink[k]-v);
      const norm = delta.reduce((sum,v) => sum+v*v,0);
      const coloredBase = false;
      const sourceInkIsTargetInk = (this.direction === 'Reverse') === coloredBase;
      const neutralWhite = [245,245,245];
      const targetInk = sourceInkIsTargetInk ? rgb : neutralWhite;
      const targetWhite = sourceInkIsTargetInk ? neutralWhite : rgb;
      for (let y=bounds[2];y<bounds[3];y++) {
        for (let x=bounds[0];x<bounds[1];x++) {
          const i=(y*source.width+x)*4;
          let t=0;
          for(let k=0;k<3;k++) t+=(original[i+k]-white[k])*delta[k];
          t=Math.max(0,Math.min(1,t/norm));
          const alpha=t*t*(3-2*t);
          const sourceLight=(original[i]+original[i+1]+original[i+2])/3;
          const expectedLight=(white[0]+white[1]+white[2]+alpha*(delta[0]+delta[1]+delta[2]))/3;
          const texture=sourceLight/Math.max(1,expectedLight);
          for(let k=0;k<3;k++) {
            const target=targetWhite[k]*(1-alpha)+targetInk[k]*alpha;
            output.data[i+k]=target*texture;
          }
        }
      }
      context.putImageData(output,0,0);
      this._previewCanvas.setAttribute('aria-label', this.colorway + ', ' + this.direction.toLowerCase() + ' color placement');
    } },
"marlowe": { source: "https://cdn.shopify.com/s/files/1/0086/7103/5455/files/marlowe-two-hues.png?v=1790952950", colors: [{"name": "Black", "hex": "#1c1c1c", "source": "Charcoal"}, {"name": "Chartreuse", "hex": "#aa9017", "source": "Chartreuse"}, {"name": "Cherry Red", "hex": "#c50603", "source": "Cherry"}, {"name": "Gray", "hex": "#8a9496", "source": "Dove"}, {"name": "Sage", "hex": "#97a191", "source": "Eucalyptus"}, {"name": "Dusty Blue", "hex": "#7e9aae", "source": "Hydrangea"}, {"name": "Jade", "hex": "#6aa496", "source": "Jade"}, {"name": "Lavender", "hex": "#9e9dae", "source": "Lavender"}, {"name": "Lime", "hex": "#b4b777", "source": "Lime"}, {"name": "Navy", "hex": "#052d4a", "source": "Navy"}, {"name": "Olive", "hex": "#758451", "source": "Olive"}, {"name": "Pink", "hex": "#ee98b5", "source": "Peony"}, {"name": "Powder Blue", "hex": "#99b2ba", "source": "Powder"}, {"name": "Rose", "hex": "#da979f", "source": "Rose"}, {"name": "Sand", "hex": "#baac96", "source": "Sand"}, {"name": "Seafoam", "hex": "#a7bbb9", "source": "Seaglass"}, {"name": "Brown", "hex": "#79553d", "source": "Brown"}, {"name": "Peach", "hex": "#edad82", "source": "Tangerine"}, {"name": "Cranberry", "hex": "#8b2942", "source": "Cranberry"}, {"name": "Kelly Green", "hex": "#248b45", "source": "Kelly Green"}, {"name": "Butter", "hex": "#f4edb6", "source": "Butter"}, {"name": "Burnt Orange", "hex": "#bf5700", "source": "Burnt Orange"}, {"name": "Tangerine", "hex": "#ed872d", "source": "Tangerine"}, {"name": "Yellow", "hex": "#f2ce25", "source": "Yellow"}, {"name": "Mocha", "hex": "#a18470", "source": "Mocha"}], u_DrawPreview() {
      if (!this._previewSource || !this._previewCanvas) return;
      const selected = this.colors.find(item => item.name === this.colorway);
      if (!selected) return;
      const source = this._previewSource;
      const context = this._previewCanvas.getContext('2d');
      const original = source.data;
      const output = new ImageData(new Uint8ClampedArray(original), source.width, source.height);
      const rgb = selected.hex.match(/[a-f0-9]{2}/gi).map(value => parseInt(value, 16));
      const bounds = [Math.ceil(source.width * .059), Math.floor(source.width * .941), Math.ceil(source.height * .0595), Math.floor(source.height * .929)];
      if (!this._photoColors) {
        const samples = [];
        for (let y = bounds[2]; y < bounds[3]; y += 5) {
          for (let x = bounds[0]; x < bounds[1]; x += 5) {
            const i = (y * source.width + x) * 4;
            samples.push([original[i], original[i+1], original[i+2]]);
          }
        }
        const light = p => (p[0] + p[1] + p[2]) / 3;
        samples.sort((a,b) => light(a) - light(b));
        let centers = [samples[Math.floor(samples.length * .15)].slice(), samples[Math.floor(samples.length * .85)].slice()];
        for (let pass = 0; pass < 12; pass++) {
          const sums = [[0,0,0,0],[0,0,0,0]];
          for (const p of samples) {
            const distances = centers.map(c => p.reduce((sum,v,k) => sum + (v-c[k]) ** 2, 0));
            const group = distances[0] < distances[1] ? 0 : 1;
            for (let k=0;k<3;k++) sums[group][k] += p[k];
            sums[group][3]++;
          }
          centers = centers.map((c,g) => sums[g][3] ? sums[g].slice(0,3).map(v => v/sums[g][3]) : c);
        }
        centers.sort((a,b) => light(a) - light(b));
        this._photoColors = centers;
      }
      const [ink, white] = this._photoColors;
      const delta = white.map((v,k) => ink[k]-v);
      const norm = delta.reduce((sum,v) => sum+v*v,0);
      const coloredBase = false;
      const sourceInkIsTargetInk = (this.direction === 'Reverse') === coloredBase;
      const neutralWhite = [245,245,245];
      const targetInk = sourceInkIsTargetInk ? rgb : neutralWhite;
      const targetWhite = sourceInkIsTargetInk ? neutralWhite : rgb;
      for (let y=bounds[2];y<bounds[3];y++) {
        for (let x=bounds[0];x<bounds[1];x++) {
          const i=(y*source.width+x)*4;
          let t=0;
          for(let k=0;k<3;k++) t+=(original[i+k]-white[k])*delta[k];
          t=Math.max(0,Math.min(1,t/norm));
          const alpha=t*t*(3-2*t);
          const sourceLight=(original[i]+original[i+1]+original[i+2])/3;
          const expectedLight=(white[0]+white[1]+white[2]+alpha*(delta[0]+delta[1]+delta[2]))/3;
          const texture=sourceLight/Math.max(1,expectedLight);
          for(let k=0;k<3;k++) {
            const target=targetWhite[k]*(1-alpha)+targetInk[k]*alpha;
            output.data[i+k]=target*texture;
          }
        }
      }
      context.putImageData(output,0,0);
      this._previewCanvas.setAttribute('aria-label', this.colorway + ', ' + this.direction.toLowerCase() + ' color placement');
    } },
"miramar": { source: "https://cdn.shopify.com/s/files/1/0086/7103/5455/files/miramar-two-hues-photo-main.jpg?v=1790892251", colors: [{"name": "Black", "hex": "#1c1c1c", "source": "Charcoal"}, {"name": "Chartreuse", "hex": "#aa9017", "source": "Chartreuse"}, {"name": "Cherry Red", "hex": "#c50603", "source": "Cherry"}, {"name": "Gray", "hex": "#8a9496", "source": "Dove"}, {"name": "Sage", "hex": "#97a191", "source": "Eucalyptus"}, {"name": "Dusty Blue", "hex": "#7e9aae", "source": "Hydrangea"}, {"name": "Jade", "hex": "#6aa496", "source": "Jade"}, {"name": "Lavender", "hex": "#9e9dae", "source": "Lavender"}, {"name": "Lime", "hex": "#b4b777", "source": "Lime"}, {"name": "Navy", "hex": "#052d4a", "source": "Navy"}, {"name": "Olive", "hex": "#758451", "source": "Olive"}, {"name": "Pink", "hex": "#ee98b5", "source": "Peony"}, {"name": "Powder Blue", "hex": "#99b2ba", "source": "Powder"}, {"name": "Rose", "hex": "#da979f", "source": "Rose"}, {"name": "Sand", "hex": "#baac96", "source": "Sand"}, {"name": "Seafoam", "hex": "#a7bbb9", "source": "Seaglass"}, {"name": "Brown", "hex": "#79553d", "source": "Brown"}, {"name": "Peach", "hex": "#edad82", "source": "Tangerine"}, {"name": "Cranberry", "hex": "#8b2942", "source": "Cranberry"}, {"name": "Kelly Green", "hex": "#248b45", "source": "Kelly Green"}, {"name": "Butter", "hex": "#f4edb6", "source": "Butter"}, {"name": "Burnt Orange", "hex": "#bf5700", "source": "Burnt Orange"}, {"name": "Tangerine", "hex": "#ed872d", "source": "Tangerine"}, {"name": "Yellow", "hex": "#f2ce25", "source": "Yellow"}, {"name": "Mocha", "hex": "#a18470", "source": "Mocha"}], u_DrawPreview() {
      if (!this._previewSource || !this._previewCanvas) return;
      const selected = this.colors.find(item => item.name === this.colorway);
      if (!selected) return;
      const rgb = selected.hex.match(/[a-f0-9]{2}/gi).map(value => parseInt(value, 16));
      const output = new ImageData(new Uint8ClampedArray(this._previewSource.data), this._previewSource.width, this._previewSource.height);
      const pixels = output.data;
      const original = this._previewSource.data;
      const width = output.width;
      // Fine, tightly packed oval knot rows. Cache the lighting independently
      // of the yarn colors so every colorway and placement shares the texture.
      if (!this._knotTexture || this._knotTexture.length !== width * output.height) {
        this._knotTexture = new Float32Array(width * output.height);
        const pitchX = width / 310;
        const pitchY = pitchX * .74;
        for (let y = 0; y < output.height; y++) {
          const row = Math.floor(y / pitchY);
          const fy = (y / pitchY) % 1;
          for (let x = 0; x < width; x++) {
            const fx = (x / pitchX + (row % 2) * .5) % 1;
            const crown = Math.sin(Math.PI * fx) * Math.sin(Math.PI * fy);
            const grain = Math.sin(x * 12.9898 + y * 78.233) * 43758.5453;
            this._knotTexture[y * width + x] = .948 + .085 * crown + .018 * (grain - Math.floor(grain) - .5);
          }
        }
      }
      for (let y = Math.ceil(output.height * .061); y < output.height * .920; y++) {
        for (let x = Math.ceil(width * .060); x < width * .940; x++) {
          const i = (y * width + x) * 4;
          const mask = Math.max(0, Math.min(1, (original[i + 2] - original[i] + 5) / 21));
          // Saturate the white motif in Reverse while retaining a short,
          // antialiased transition at its edge and the original wool texture.
          const edge = Math.max(0, Math.min(1, (mask - .12) / .48));
          const placementMask = edge * edge * (3 - 2 * edge);
          const field = this.direction === 'Original' ? [250, 250, 247] : rgb;
          const motif = this.direction === 'Original' ? rgb : [250, 250, 247];
          const light = (original[i] + original[i + 1] + original[i + 2]) / 3;
          const texture = Math.max(.88, Math.min(1.03, (light + placementMask * 48) / 224)) * this._knotTexture[y * width + x];
          for (let channel = 0; channel < 3; channel++) pixels[i + channel] = (field[channel] * (1 - placementMask) + motif[channel] * placementMask) * texture;
        }
      }
      this._previewCanvas.getContext('2d').putImageData(output, 0, 0);
      this._previewCanvas.setAttribute('aria-label', 'Miramar in ' + this.colorway + ', ' + this.direction.toLowerCase() + ' color placement');
    } },
"point-taken": { source: "https://cdn.shopify.com/s/files/1/0086/7103/5455/files/point-taken-lime-original-concept.png?v=1790880330", colors: [{"name": "Black", "hex": "#1c1c1c", "source": "Charcoal"}, {"name": "Chartreuse", "hex": "#aa9017", "source": "Chartreuse"}, {"name": "Cherry Red", "hex": "#c50603", "source": "Cherry"}, {"name": "Gray", "hex": "#8a9496", "source": "Dove"}, {"name": "Sage", "hex": "#97a191", "source": "Eucalyptus"}, {"name": "Dusty Blue", "hex": "#7e9aae", "source": "Hydrangea"}, {"name": "Jade", "hex": "#6aa496", "source": "Jade"}, {"name": "Lavender", "hex": "#9e9dae", "source": "Lavender"}, {"name": "Lime", "hex": "#b4b777", "source": "Lime"}, {"name": "Navy", "hex": "#052d4a", "source": "Navy"}, {"name": "Olive", "hex": "#758451", "source": "Olive"}, {"name": "Pink", "hex": "#ee98b5", "source": "Peony"}, {"name": "Powder Blue", "hex": "#99b2ba", "source": "Powder"}, {"name": "Rose", "hex": "#da979f", "source": "Rose"}, {"name": "Sand", "hex": "#baac96", "source": "Sand"}, {"name": "Seafoam", "hex": "#a7bbb9", "source": "Seaglass"}, {"name": "Brown", "hex": "#79553d", "source": "Brown"}, {"name": "Peach", "hex": "#edad82", "source": "Tangerine"}, {"name": "Cranberry", "hex": "#8b2942", "source": "Cranberry"}, {"name": "Kelly Green", "hex": "#248b45", "source": "Kelly Green"}, {"name": "Butter", "hex": "#f4edb6", "source": "Butter"}, {"name": "Burnt Orange", "hex": "#bf5700", "source": "Burnt Orange"}, {"name": "Tangerine", "hex": "#ed872d", "source": "Tangerine"}, {"name": "Yellow", "hex": "#f2ce25", "source": "Yellow"}, {"name": "Mocha", "hex": "#a18470", "source": "Mocha"}], u_DrawPreview() {
      if (!this._previewSource || !this._previewCanvas) return;
      const selected = this.colors.find(item => item.name === this.colorway);
      if (!selected) return;
      const rgb = selected.hex.match(/[a-f0-9]{2}/gi).map(value => parseInt(value, 16));
      const output = new ImageData(new Uint8ClampedArray(this._previewSource.data), this._previewSource.width, this._previewSource.height);
      const pixels = output.data;
      const original = this._previewSource.data;
      const width = output.width;
      // Fine, tightly packed oval knot rows. Cache the lighting independently
      // of the yarn colors so every colorway and placement shares the texture.
      if (!this._knotTexture || this._knotTexture.length !== width * output.height) {
        this._knotTexture = new Float32Array(width * output.height);
        const pitchX = width / 310;
        const pitchY = pitchX * .74;
        for (let y = 0; y < output.height; y++) {
          const row = Math.floor(y / pitchY);
          const fy = (y / pitchY) % 1;
          for (let x = 0; x < width; x++) {
            const fx = (x / pitchX + (row % 2) * .5) % 1;
            const crown = Math.sin(Math.PI * fx) * Math.sin(Math.PI * fy);
            const grain = Math.sin(x * 12.9898 + y * 78.233) * 43758.5453;
            this._knotTexture[y * width + x] = .948 + .085 * crown + .018 * (grain - Math.floor(grain) - .5);
          }
        }
      }
      for (let y = Math.ceil(output.height * .0595); y < output.height * .929; y++) {
        for (let x = Math.ceil(width * .059); x < width * .941; x++) {
          const i = (y * width + x) * 4;
          const mask = Math.max(0, Math.min(1, (original[i + 1] - original[i + 2] - 8) / 57));
          // Saturate the white motif in Reverse while retaining a short,
          // antialiased transition at its edge and the original wool texture.
          const edge = Math.max(0, Math.min(1, (mask - .12) / .48));
          const placementMask = this.direction === 'Reverse' ? edge * edge * (3 - 2 * edge) : mask;
          const field = this.direction === 'Original' ? [250, 250, 247] : rgb;
          const motif = this.direction === 'Original' ? rgb : [250, 250, 247];
          const light = (original[i] + original[i + 1] + original[i + 2]) / 3;
          const texture = Math.max(.88, Math.min(1.03, (light + mask * 76) / 247)) * this._knotTexture[y * width + x];
          for (let channel = 0; channel < 3; channel++) pixels[i + channel] = (field[channel] * (1 - placementMask) + motif[channel] * placementMask) * texture;
        }
      }
      this._previewCanvas.getContext('2d').putImageData(output, 0, 0);
      this._previewCanvas.setAttribute('aria-label', 'Point Taken in ' + this.colorway + ', ' + this.direction.toLowerCase() + ' color placement');
    } },
"vivian": { source: "https://cdn.shopify.com/s/files/1/0086/7103/5455/files/vivian-two-hues.png?v=1790951710", colors: [{"name": "Black", "hex": "#1c1c1c", "source": "Charcoal"}, {"name": "Chartreuse", "hex": "#aa9017", "source": "Chartreuse"}, {"name": "Cherry Red", "hex": "#c50603", "source": "Cherry"}, {"name": "Gray", "hex": "#8a9496", "source": "Dove"}, {"name": "Sage", "hex": "#97a191", "source": "Eucalyptus"}, {"name": "Dusty Blue", "hex": "#7e9aae", "source": "Hydrangea"}, {"name": "Jade", "hex": "#6aa496", "source": "Jade"}, {"name": "Lavender", "hex": "#9e9dae", "source": "Lavender"}, {"name": "Lime", "hex": "#b4b777", "source": "Lime"}, {"name": "Navy", "hex": "#052d4a", "source": "Navy"}, {"name": "Olive", "hex": "#758451", "source": "Olive"}, {"name": "Pink", "hex": "#ee98b5", "source": "Peony"}, {"name": "Powder Blue", "hex": "#99b2ba", "source": "Powder"}, {"name": "Rose", "hex": "#da979f", "source": "Rose"}, {"name": "Sand", "hex": "#baac96", "source": "Sand"}, {"name": "Seafoam", "hex": "#a7bbb9", "source": "Seaglass"}, {"name": "Brown", "hex": "#79553d", "source": "Brown"}, {"name": "Peach", "hex": "#edad82", "source": "Tangerine"}, {"name": "Cranberry", "hex": "#8b2942", "source": "Cranberry"}, {"name": "Kelly Green", "hex": "#248b45", "source": "Kelly Green"}, {"name": "Butter", "hex": "#f4edb6", "source": "Butter"}, {"name": "Burnt Orange", "hex": "#bf5700", "source": "Burnt Orange"}, {"name": "Tangerine", "hex": "#ed872d", "source": "Tangerine"}, {"name": "Yellow", "hex": "#f2ce25", "source": "Yellow"}, {"name": "Mocha", "hex": "#a18470", "source": "Mocha"}], u_DrawPreview() {
      if (!this._previewSource || !this._previewCanvas) return;
      const selected = this.colors.find(item => item.name === this.colorway);
      if (!selected) return;
      const source = this._previewSource;
      const context = this._previewCanvas.getContext('2d');
      const original = source.data;
      const output = new ImageData(new Uint8ClampedArray(original), source.width, source.height);
      const rgb = selected.hex.match(/[a-f0-9]{2}/gi).map(value => parseInt(value, 16));
      const bounds = [Math.ceil(source.width * .059), Math.floor(source.width * .941), Math.ceil(source.height * .0595), Math.floor(source.height * .929)];
      if (!this._photoColors) {
        const samples = [];
        for (let y = bounds[2]; y < bounds[3]; y += 5) {
          for (let x = bounds[0]; x < bounds[1]; x += 5) {
            const i = (y * source.width + x) * 4;
            samples.push([original[i], original[i+1], original[i+2]]);
          }
        }
        const light = p => (p[0] + p[1] + p[2]) / 3;
        samples.sort((a,b) => light(a) - light(b));
        let centers = [samples[Math.floor(samples.length * .15)].slice(), samples[Math.floor(samples.length * .85)].slice()];
        for (let pass = 0; pass < 12; pass++) {
          const sums = [[0,0,0,0],[0,0,0,0]];
          for (const p of samples) {
            const distances = centers.map(c => p.reduce((sum,v,k) => sum + (v-c[k]) ** 2, 0));
            const group = distances[0] < distances[1] ? 0 : 1;
            for (let k=0;k<3;k++) sums[group][k] += p[k];
            sums[group][3]++;
          }
          centers = centers.map((c,g) => sums[g][3] ? sums[g].slice(0,3).map(v => v/sums[g][3]) : c);
        }
        centers.sort((a,b) => light(a) - light(b));
        this._photoColors = centers;
      }
      const [ink, white] = this._photoColors;
      const delta = white.map((v,k) => ink[k]-v);
      const norm = delta.reduce((sum,v) => sum+v*v,0);
      const coloredBase = false;
      const sourceInkIsTargetInk = (this.direction === 'Reverse') === coloredBase;
      const neutralWhite = [245,245,245];
      const targetInk = sourceInkIsTargetInk ? rgb : neutralWhite;
      const targetWhite = sourceInkIsTargetInk ? neutralWhite : rgb;
      for (let y=bounds[2];y<bounds[3];y++) {
        for (let x=bounds[0];x<bounds[1];x++) {
          const i=(y*source.width+x)*4;
          let t=0;
          for(let k=0;k<3;k++) t+=(original[i+k]-white[k])*delta[k];
          t=Math.max(0,Math.min(1,t/norm));
          const alpha=t*t*(3-2*t);
          const sourceLight=(original[i]+original[i+1]+original[i+2])/3;
          const expectedLight=(white[0]+white[1]+white[2]+alpha*(delta[0]+delta[1]+delta[2]))/3;
          const texture=sourceLight/Math.max(1,expectedLight);
          for(let k=0;k<3;k++) {
            const target=targetWhite[k]*(1-alpha)+targetInk[k]*alpha;
            output.data[i+k]=target*texture;
          }
        }
      }
      context.putImageData(output,0,0);
      this._previewCanvas.setAttribute('aria-label', this.colorway + ', ' + this.direction.toLowerCase() + ' color placement');
    } }
  };
  const sources = new Map();
  const load = (url) => {
    if (!sources.has(url)) sources.set(url, new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = url;
    }).catch(error => { sources.delete(url); throw error; }));
    return sources.get(url);
  };
  const render = async (node) => {
    if (node.dataset.rendered) return;
    node.dataset.rendered = 'pending';
    const entry = Object.entries(designs).find(([name]) => node.dataset.template.startsWith(name));
    if (!entry) return;
    try {
      const design = entry[1];
      const photo = await load(design.source);
      const canvas = document.createElement('canvas');
      canvas.width = photo.naturalWidth;
      canvas.height = photo.naturalHeight;
      const context = canvas.getContext('2d');
      context.drawImage(photo, 0, 0);
      const state = {
        colors: design.colors,
        colorway: node.dataset.colorway,
        direction: node.dataset.direction,
        _previewSource: context.getImageData(0, 0, canvas.width, canvas.height),
        _previewCanvas: canvas
      };
      design.u_DrawPreview.call(state);
      if (!canvas.hasAttribute('aria-label')) return;
      canvas.setAttribute('role', 'img');
      canvas.setAttribute('aria-label', node.dataset.label);
      canvas.style.cssText = 'display:block;width:100%;height:auto';
      node.replaceChildren(canvas);
      node.dataset.rendered = 'done';
    } catch (error) {
      node.dataset.rendered = 'failed';
    }
  };
  const scan = (root) => {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches?.('[data-two-hues-cart-image]')) render(root);
    root.querySelectorAll('[data-two-hues-cart-image]').forEach(render);
  };
  scan(document);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(scan))).observe(document.body, {childList:true, subtree:true});
})();
